import type { BookingAddOn } from '@rover/types';
import Enum from '@rover/types/src/Enum';
import type { ServiceType } from '@rover/types/src/ServiceType';
import { ServiceTypeDefaults, ServiceTypeSlug } from '@rover/types/src/ServiceType';

export type Service = {
  title: string;
  name: string;
  displayName: string;
  slug: string;
  meta: any;
  serviceAddOns: BookingAddOn[];
  serviceType: ServiceType;
  urls: Record<string, string | null | undefined>;
  url: string;
  isAcceptingNewCustomers?: boolean;
  isRepeatCustomersOnly: boolean;
  isAcceptingNewOneTimeCustomersOnly: boolean;
  isAcceptingNewRecurringClientsOnly: boolean;
} & any;

export const ServiceDefaults: Service = {
  title: '',
  name: '',
  displayName: '',
  slug: '',
  meta: {},
  serviceAddOns: [],
  serviceType: ServiceTypeDefaults,
  urls: {},
  url: '',
  isAcceptingNewCustomers: true,
  isRepeatCustomersOnly: false,
  isAcceptingNewOneTimeCustomersOnly: false,
  isAcceptingNewRecurringClientsOnly: false,
};

export const REQUESTER_HOME = 'requester_home';
export const PROVIDER_HOME = 'provider_home';

/**
 * @deprecated opt for using `ServiceTypeSlug` exported from `@rover/types/src/ServiceType`
 */
const DeprecatedServiceTypeSlug: Record<string, ServiceTypeSlug> = Object.freeze({
  overnightBoarding: ServiceTypeSlug.OVERNIGHT_BOARDING,
  overnightTraveling: ServiceTypeSlug.OVERNIGHT_TRAVELING,
  dogWalking: ServiceTypeSlug.DOG_WALKING,
  dropIn: ServiceTypeSlug.DROP_IN,
  doggyDayCare: ServiceTypeSlug.DOGGY_DAY_CARE,
  onDemandDogWalking: ServiceTypeSlug.ON_DEMAND_DOG_WALKING,
  onDemandGrooming: ServiceTypeSlug.ON_DEMAND_GROOMING,
  onDemandDropIn: ServiceTypeSlug.ON_DEMAND_DROP_IN,
  dogTraining: ServiceTypeSlug.DOG_TRAINING,
});

export { DeprecatedServiceTypeSlug as ServiceTypeSlugs };

export class ServiceTypeEnum extends Enum<string> {
  static WALKING = new ServiceTypeEnum('dog-walking');

  static DROPIN = new ServiceTypeEnum('drop-in');

  static DAYCARE = new ServiceTypeEnum('doggy-day-care');

  static GROOMING = new ServiceTypeEnum('on-demand-grooming');

  static urlMap = {
    // url: enum
    walking: ServiceTypeEnum.WALKING,
    'drop-ins': ServiceTypeEnum.DROPIN,
    grooming: ServiceTypeEnum.GROOMING,
  };

  static isLocked = true;

  static fromURL = (url: string): ServiceTypeEnum => {
    const urls = ServiceTypeEnum.urlMap;
    return url in urls ? urls[url] : ServiceTypeEnum.WALKING; // default to walking
  };

  toURL(): string {
    let found;
    Object.entries(ServiceTypeEnum.urlMap).every((keyVal) => {
      const [key, val] = keyVal;
      found = key;
      return val !== this;
    });
    return found || '';
  }
}
